/**
 * Store persisted states in localStorage
 * - https://docs.pmnd.rs/zustand/integrations/persisting-store-data
 */
import type { PermissionGroup } from '@dmp/qqms/permissions';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Size {
    name: string;
    width: number;
    height: number;
}

export const usePreviewZoomStore = create<{ value: number }>()(
    persist((_set, _get) => ({ value: 1 }), {
        name: 'ui_previewZoomState',
    })
);

export const usePreviewSizeStore = create<{ value: string }>()(
    persist(
        (_set, _get) => ({
            value: 'In-Article',
        }),
        {
            name: 'ui_previewSizeState',
        }
    )
);

export const useVisualTreeDimensionStore = create<{ value: number }>()(
    persist((_set, _get) => ({ value: 300 }), {
        name: 'ui_visualTreeDimension',
    })
);

export const useLeftPanelDimensionStore = create<{ value: number }>()(
    persist((_set, _get) => ({ value: 300 }), {
        name: 'ui_leftPanelDimension',
    })
);

export const useRightPanelDimensionStore = create<{ value: number }>()(
    persist((_set, _get) => ({ value: 600 }), {
        name: 'ui_rightPanelDimension',
    })
);

/**
 * Store current team ID to persist team selection across sessions.
 * This is especially useful when users are part of multiple teams.
 */
export const useCurrentTeamIdStore = create<{ value: string }>()(
    persist((_set, _get) => ({ value: '' }), {
        name: 'ui_currentTeamId',
    })
);

export type ViewAsPermissionGroup = PermissionGroup | '';

/**
 * Store current view-as permission group
 */
export const useViewAsPermissionGroupStore = create<{
    value: ViewAsPermissionGroup;
}>()(
    persist((_set, _get) => ({ value: '' }), {
        name: 'ui_viewAsPermissionGroup',
    })
);
